import React from 'react';
import {Fab as MuFab, Zoom, Badge} from '@material-ui/core';
//import {useTheme} from '@material-ui/core/styles';
//import AddIcon from '@material-ui/icons/Add';

//const theme = useTheme();

class Fab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {icon, size, color, badgeValue, badgeColor, enterTransition, exitTransition, onClick} = this.props;


        const transitionDuration = {
            enter: enterTransition || 50,
            exit: exitTransition || 50,
        };

        return (
            <div style={{position: 'fixed', bottom: 80, left: 10, marginLeft: 10}} onClick={onClick}>
                <Zoom
                    in={1 == 1}
                    //timeout={transitionDuration}
                    style={{
                        transitionDelay: `${transitionDuration.exit || 0}ms`,
                    }}
                    unmountOnExit>
                    <Badge badgeContent={badgeValue} color={badgeColor} showZero>
                        <MuFab color={color} size={size}>
                            <i className={`fa fa-${icon}`}/>
                        </MuFab>
                    </Badge>
                </Zoom>
            </div>
        );
    }
}

export default Fab;
